import { createStore } from "vuex";
import { getCourseById } from "@/Services/api/CoursesService";
import { login, newRefreshToken } from "@/Services/api/AuthService";
import { getSpecializationDropdown } from "@/Services/api/SpecializationService";
import reviews from "./reviews";
import { getPageByCode } from "@/Services/api/PagesService";
import PagesCodes from "@/constants/PagesCode";
//import auth from "./auth";
export default createStore({
  state: {
    language: localStorage.getItem("language") || "ar",
    direction: localStorage.getItem("direction") || "rtl",
    categoryID: null,
    AssetUrl: process.env.VUE_APP_ASSETS_URL,
    comments: [],
    userEmail: localStorage.getItem("userEmail") || "",
    otp: null,
    courseItem: null,
    loading: false,
    error: null,
    otpExpirationTime: null, // Timestamp for when the OTP will expire
    ///User data
    token: localStorage.getItem("accessToken") || "",
    TokenExpiration: "",
    refreshToken: "",
    refreshTokenExpirationDate: "",
    userData: localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null,
    isAuthenticated: false,
    idToken: localStorage.getItem('idToken') || null,
    googleUserData: localStorage.getItem("googleUserData") ? JSON.parse(localStorage.getItem("googleUserData")) : null,
    categories: null,
    seoData: null,
    clients : null,
    homeViedo:''
  },
  getters: {
    currentLanguage(state) {
      return state.language; 
    },
    currentDirection(state) {
      return state.direction;
    },
    userEmail(state) {
      return state.userEmail;
    },
    courseItem(state) {
      return state.courseItem;
    },
    isLoading(state) {
      return state.loading;
    },
    error(state) {
      return state.error;
    },
    categories(state){
      return state.categories
    },
    /*****user Account**********/
    token(state) {
     // alert(state.token)
      return state.token;
    },
    getUserData(state) {
      return state.userData;
    },
    TokenExpiration(state) {
      return state.TokenExpiration;
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
     // return !!state.token && localStorage.getItem("authToken")
    },
    idToken(state) {
      return state.idToken
    },
    seoData(state){
      return state.seoData
    },
    getclients(state){
      return state.clients
    },
    getVideo(state){
      return state.homeViedo
    }
  },
  mutations: {
    setCategories(state , payload){
      state.categories  = payload
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setDirection(state, direction) {
      state.direction = direction;
    },
    setCategoryID(state, id) {
      state.categoryID = id;
    },
    setComments(state, payload) {
      state.comments = payload;
    },
    setUserEmail(state, payload) {
      state.userEmail = payload;
      localStorage.setItem("userEmail", payload);
    },
    /***** Course Mutations *****/
    setCourseDetails(state, courseItem) {
      state.courseItem = courseItem;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
    /*****User Account*********/
    SetToken(state, payload) {
      state.token = payload;
    },
    setUserData(state, payload) {
      state.userData = payload;
      localStorage.setItem("userData", JSON.stringify(payload));
    },
    setRefreshToken(state, payload) {
      state.refreshToken = payload;
      localStorage.setItem("refreshToken", payload);
    },
    setIsAuthenticated(state,payload){
      state.isAuthenticated = payload
    },
    updataIdToken(state, payload) {
      state.idToken = payload;
      localStorage.setItem('idToken', payload);
    },
    setGoogleData(state,payload){
      state.googleUserData = payload;
      localStorage.setItem("googleUserData", JSON.stringify(payload));
    },
    logout(state) {
      state.token = "";
      state.userData = null;
      state.isAuthenticated = false;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userData");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("accessTokenExpirationDate");
      localStorage.removeItem("refreshTokenExpirationDate");
      localStorage.removeItem('idToken');
      localStorage.removeItem("googleUserData");
    },
    setSeoData(state,payload){
      state.seoData = payload
    },
    setclients(state, payload){
      state.clients = payload
    },
    setHomeVideo(state,payload){
      state.homeViedo = payload
    }
  },
  actions: {
    updateLanguage({ commit }, newLanguage) {
      commit("setLanguage", newLanguage);
    },
    updateDirection({ commit }, newDirection) {
      commit("setDirection", newDirection);
    },
    updateUserEmail({ commit }, email) {
      commit("setUserEmail", email);
    },
    async getCategories({ commit, state }) {
      const isArabic = state.language === 'ar';
      const fixedCategories = [
        {
          id: 1, // CourseCategory.Development
          name: isArabic ? 'دورات تطويرية' : 'Development Courses',
          type: 'category'
        },
        {
          id: 2, // CourseCategory.Qualification
          name: isArabic ? 'دورات تأهيلية' : 'Qualification Courses',
          type: 'category'
        },
        {
          id: 0,
          name: isArabic ? 'الدبلومات' : 'Diplomas',
          type: 'diploma'
        }
      ];
      commit('setCategories', fixedCategories);
    },
    /******get Clients**********/
    async fetchClients({commit}) {
        try{
          const response = await getPageByCode(PagesCodes.OurClients);
          commit('setclients',response.data.clients)
        //  console.log(response.data.clients)
        } catch (error){
          console.log(error)
        }
      },
    /***** Course Actions *****/
    async fetchCourseDetails({ commit }, courseId) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const response = await getCourseById(courseId);
        commit("setCourseDetails", response.data);
        commit("setSeoData", response.data.seo); // Assuming response.data contains the course details
      } catch (error) {
        commit("setError", error.message || "An unknown error occurred.");
      } finally {
        commit("setLoading", false);
      }
    },
    /******Login Action***********/
    async loginAction({ commit }, userData) {
      try {
        const response = await login(userData.email, userData.password);
        commit("setToken", response.data.accessToken);
        commit("setUserData", response.data.userData);
        commit("setRefreshToken", response.data.refreshToken);
       
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("accessTokenExpirationDate", response.data.accessTokenExpirationDate);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        localStorage.setItem("refreshTokenExpirationDate", response.data.refreshTokenExpirationDate);
      } catch (error) {
        throw new Error(
          error.response?.data?.message || "Login failed. Please try again."
        );
      }
    },

    /***refresh token*****/
    async refreshTokenAction({ commit, state }) {
      try {
        const response = await newRefreshToken({ token: state.token, refreshToken: state.refreshToken });
        commit("setToken", response.data.token);
        localStorage.setItem("accessToken", response.data.token);
        // commit("setRefreshToken", response.data.refreshToken);
        localStorage.setItem("accessTokenExpirationDate", response.data.expirationDate);
      } catch (error) {
        // alert('Failed to refresh token:', error);
      }
    }
  },
  modules: {
    reviews
  },
});
